

<template>
	<div class="text-center language-container">
		<v-menu offset-y>
			<template v-slot:activator="{ on, attrs }">
				<v-btn @click="show = !show" v-bind="attrs" v-on="on" class="language-button">
					<v-img
						class="paises"
						:src="
							activeLang === 'CA'
								? require('@/assets/images/paises/VAL2.png')
								: require('@/assets/images/paises/' + activeLang + '.png')
						"
						max-width="1.5rem"
						alt="pais"
					></v-img>
					{{ LangToShow(activeLang) }}
					<v-icon x-small style="margin-left: 4px">{{ show ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}</v-icon>
				</v-btn>
			</template>
			<v-list>
				<v-list-item v-for="(lang, index) in languages" :key="index" @click="changeLanguage(lang)">
					<v-img
						class="paises"
						:src="lang === 'CA' ? require('@/assets/images/paises/VAL2.png') : require('@/assets/images/paises/' + lang + '.png')"
						max-width="1.5rem"
						alt="pais"
					></v-img>
					<v-list-item-title class="language-item">{{ LangToShow(lang) }}</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-menu>
	</div>
</template>

<script>
export default {
	name: 'LanguageSelector',

	data() {
		return {
			languages: [],
			activeLang: '',
			show: false
		};
	},
	created() {
		this.getLanguages();
		this.getActiveLanguage();
	},
	methods: {
		getLanguages() {
			let langs = '';
			if (this.$store.state.eventInfo.evencataloglanguages === '*') {
				langs = ['es', 'en', 'ca'];
			} else {
				langs = this.$store.state.eventInfo.evencataloglanguages;
				langs = langs.split(',');
			}
			this.languages = langs.map((lang) => lang.toUpperCase());
		},

		getActiveLanguage() {
			if (window.localStorage.getItem('anonymous_session')) {
				this.activeLang = window.localStorage.getItem('pui9_lang').toUpperCase();
			} else {
				const session = JSON.parse(window.localStorage.getItem('pui9_session'));

				if (!this.languages.includes(session.language.toUpperCase())) {
					this.activeLang = 'ES';
				} else {
					// this.activeLang = session.language.toUpperCase();
					this.activeLang = window.localStorage.getItem('pui9_lang').toUpperCase();
				}
			}
		},

		changeLanguage(lang) {
			const isocode = lang.toLowerCase();
			window.localStorage.setItem('pui9_lang', isocode);
			this.$store.commit('setUserLanguage', isocode);
			this.$store.commit('setHttpRequestHeaders', { acceptLanguage: isocode });
			this.$puiEvents.$emit('onPuiChangedLang', isocode);
			this.activeLang = lang;
			this.$store.state.activeLanguage = this.activeLang;

			this.$puiEvents.$emit('language-changed', this.activeLang);
		},

		LangToShow: function (lang) {
			if (lang === 'CA') return 'VA';
			else return lang;
		}
	}
};
</script>

<style scoped>
.language-container {
	margin-top: 4.5%;
}

.language-button {
	border: 1px solid #d2d7d9;
	border-radius: 8px;
	background: none !important;
	box-shadow: none !important;
}

.language-item {
	cursor: pointer;
}

.paises {
	margin-right: 8px;
	border-radius: 4px;
}
</style>


